import React from 'react';

function isChunkLoadError(error) {
  const msg = String(error?.message || error || '');
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('ChunkLoadError') ||
    msg.includes('Loading chunk') ||
    msg.includes('Unable to preload CSS')
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    if (isChunkLoadError(error)) {
      const reloadKey = `chunk_reload_${window.location.pathname}`;
      const lastReload = Number(sessionStorage.getItem(reloadKey) || 0);
      if (Date.now() - lastReload > 15000) {
        sessionStorage.setItem(reloadKey, String(Date.now()));
        window.location.reload();
        return;
      }
    }
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleGoBack = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    if (this.props.onBack) {
      this.props.onBack();
    } else if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ color: '#d32f2f' }}>Something went wrong.</h2>
          <p>We're sorry, but there was an error loading this component.</p>
          {this.state.error && (
            <p style={{ color: '#666', fontSize: '13px', fontFamily: 'monospace' }}>
              {this.state.error.message || this.state.error.toString()}
            </p>
          )}
          <div style={{ marginTop: '20px' }}>
            <button 
              onClick={() => window.location.reload()}
              style={{
                backgroundColor: '#2196f3',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px'
              }}
            >
              Reload Page
            </button>
            <button 
              onClick={this.handleGoBack}
              style={{
                backgroundColor: '#f5f5f5',
                color: '#333',
                border: '1px solid #ccc',
                padding: '10px 20px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px',
                marginLeft: '10px'
              }}
            >
              Go Back
            </button>
          </div>
          {process.env.NODE_ENV !== 'production' && this.state.error && (
            <div style={{ 
              marginTop: '20px', 
              textAlign: 'left',
              backgroundColor: '#f5f5f5',
              padding: '15px',
              borderRadius: '4px',
              overflow: 'auto',
              maxHeight: '300px'
            }}>
              <p><strong>Error:</strong> {this.state.error.toString()}</p>
              <p><strong>Stack:</strong></p>
              <pre style={{ whiteSpace: 'pre-wrap' }}>
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

